'use client'
import { CheckIcon } from '@radix-ui/react-icons'
import * as React from 'react'
import { useFormStatus } from 'react-dom'
import { Button, ButtonProps } from '~/sotano-kit/primitives/button'

export const SubscribeButton = ({
  ...props
}: Pick<ButtonProps, 'intent' | 'size' | 'className'>) => {
  const { pending } = useFormStatus()
  const [hasBeenPendingOnce, setHasBeenPendingOnce] = React.useState(false)
  const isSuccess = !pending && hasBeenPendingOnce

  React.useEffect(() => {
    if (!pending) return
    setHasBeenPendingOnce(true)
  }, [pending])

  // clear
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setHasBeenPendingOnce(false)
    }, 5_000)

    return () => clearTimeout(timeout)
  }, [isSuccess])

  return (
    <Button intent="secondary" {...props}>
      {pending ? (
        'Submitting...'
      ) : isSuccess ? (
        <>
          Subscribed <CheckIcon />
        </>
      ) : (
        'Subscribe'
      )}
    </Button>
  )
}
